export default __webpack_public_path__ + "static/media/sonicmovers-logo.20e39e92.jpg";